import React, { Component } from "react";
import { Routes, Route, Outlet, Link } from "react-router-dom";
import VehcileList from "./VehiclesList";
import AddVehicle from "./AddVehicle";
import VehiclePage from "./VehiclePage";
import {AuthComponents} from "../../lib/_sso";

export default class VehiclePages extends Component {
  render() {
    return (
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<VehcileList />} />
          <Route path="/:vehicle_id" element={<VehiclePage />} />
          <Route path="/edit/:vehicle_id" element={<AddVehicle />} />
          <Route path="/add" element={<AddVehicle />} />
          <Route path="*" element={<NoMatch2 />} />
        </Route>
      </Routes>
    );
  }
}
function Layout() {
  const scope = ["teamsite:admin", "teamsite:management"];

  return (
    <div className="min-h-full">
      <main>
        <AuthComponents.Can scope={scope}>
          <Outlet />
        </AuthComponents.Can>
        <AuthComponents.CanNot scope={scope}>
          <div className={"p-2 text-red-500"}>Access Denied: You do not have permission to access this page.</div>
        </AuthComponents.CanNot>
      </main>
    </div>
  );
}
function NoMatch2() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}
